import { Grid, Tooltip } from "@mui/material";
import { Typography } from "antd";
import { useContext, useState } from "react";
import { useTranslation } from "react-i18next";
import DialogBox from "../../components/DialogBoxComponent/DialogBox";
import { ThemeContext } from "../../theme/ThemeContext";

function ManualCheckout(props) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);
  const { darkMode } = useContext(ThemeContext);

  const handleClose = () => {
    props.onClose();
  };
  const handleSubmit = () => {
    props.onSubmit();
  };

  return (
    <>
      <DialogBox
        Header={t("MANUAL_CHECK_OUT")}
        acceptText={t("CONFIRM")}
        cancelText={t("COMMON008")}
        onClose={handleClose}
        cancel={handleClose}
        onSubmit={handleSubmit}
        open={props.open}
      >
        <Grid
          container
          justifyContent="center"
          direction="column"
          alignItems="center"
          style={{
            backgroundColor: darkMode ? "#0E2A41" : "",
          }}
        >
          <Grid
            item
            style={{
              opacity: 1,
              textAlign: "center",
              display: "flex",
              flexDirection: "row",
              fontSize: "17px",
              marginTop: "15px",
              color: darkMode ? "#fff" : "#242424",
            }}
          >
            <Typography
              style={{
                fontSize: "15px",
                whiteSpace: "pre-line",
                color: darkMode ? "#fff" : "#242424",
              }}
            >
              {t("MANNUAL_CHECK_OUT_BODY")}
            </Typography>
            {/* <Tooltip title={props.visitorName}>
              <Typography
                style={{
                  fontWeight: "bold",
                  fontSize: "15px",
                  margin: "0 5px",
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",
                  maxWidth: "200px",
                  color: darkMode ? "#fff" : "#242424",
                }}
              >
                {props.visitorName}
              </Typography>
            </Tooltip> */}
            {/* <Typography
              style={{
                fontSize: "15px",
                color: darkMode ? "#fff" : "#242424",
              }}
            >
              ?
            </Typography> */}
          </Grid>
        </Grid>
      </DialogBox>
    </>
  );
}

export default ManualCheckout;
